import * as React from 'react';
import classnames from 'classnames';
import isEmpty from 'lodash/isEmpty';

import { __t, applyTranslations } from 'utils/language';

import './offer-banner-additional-compensation-descriptions.scss';

applyTranslations(require('./offer-banner-additional-compensation-descriptions.i18n.json'));

import type { OfferBannerTextStyle } from '../../types';
import type {
  OfferAdditionalCompensationData
} from 'modules/subcampaigns/components/forms/offer-additional-compensation/types';

type Props = {
  additionalCompensation: OfferAdditionalCompensationData,
  textStyle?: OfferBannerTextStyle
};

const MSG_KEY = 'offer_banner_additional_compensation_descriptions';

const OfferBannerAdditionalCompensationDescriptions: React.FC<Props> = ({
  additionalCompensation,
  textStyle
}: Props) => {
  const voucherDescription = additionalCompensation?.voucherDescription;
  const otherDescription = additionalCompensation?.otherDescription;

  if (isEmpty(voucherDescription) && isEmpty(otherDescription)) {
    return null;
  }

  const renderDescription = (
    label: string,
    description: string
  ): React.ReactNode => (
    <div
      className="offer-banner-additional-compensation-descriptions__description"
      title={`${label}: ${description}`}
    >
      <span>
        {label}:&nbsp;
      </span>
      {description}
    </div>
  );

  const renderVoucher = (): React.ReactNode => {
    const label = __t(`${MSG_KEY}.labels.voucher_description`);

    return renderDescription(label, voucherDescription);
  };

  const renderOther = (): React.ReactNode => {
    const label = __t(`${MSG_KEY}.labels.other_compensation`);

    return renderDescription(label, otherDescription);
  };

  const containerClasses = classnames(
    'offer-banner-additional-compensation-descriptions', {
      [`offer-banner-additional-compensation-descriptions--${textStyle}`]: true
    }
  );

  return (
    <div className={containerClasses}>
      {
        !isEmpty(voucherDescription) &&
          renderVoucher()
      }
      {
        !isEmpty(otherDescription) &&
          renderOther()
      }
    </div>
  );
};

export default OfferBannerAdditionalCompensationDescriptions;
